import React, { FC, memo, useState } from 'react'

import MenuList from '../MenuList'
import Popover, { PopoverProps } from '../Popover'

type PopupProps = Pick<
  PopoverProps,
  'placement' | 'width' | 'maxWidth' | 'minWidth' | 'offset' | 'appendTo' | 'open' | 'onChangeOpen'
>

export interface SubmenuProps extends React.HTMLAttributes<HTMLElement>, PopupProps {
  label: string
  icon?: React.ReactNode
  active?: boolean
}

const Subpopup: FC<React.PropsWithChildren<SubmenuProps>> = ({
  children,
  active,
  label,
  icon,
  placement = 'right-start',
  appendTo = 'parent',
  maxWidth,
  minWidth,
  width = 'auto',
  open,
  onChangeOpen,
  ...props
}) => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement>(null)

  return (
    <MenuList.Item>
      <MenuList.Label ref={setAnchorElement} icon={icon} aria-haspopup active={active} {...props}>
        {label}
      </MenuList.Label>

      <Popover
        role="combobox"
        anchorEl={anchorElement}
        placement={placement}
        appendTo={appendTo}
        maxWidth={maxWidth}
        minWidth={minWidth}
        width={width}
        open={open}
        onChangeOpen={onChangeOpen}
      >
        {children}
      </Popover>
    </MenuList.Item>
  )
}

export default memo(Subpopup)
